import React from 'react';
import {useModel} from '../../helpers/model/use_model.js';
import {GeoModel} from './geo-model.js';
import {createPath} from './functions';
import {useStateContext} from '../../helpers/state-context.js';

// This component draws a missing border inside the Kashmir region. The points below are hardcoded roughly the
// corner point along the border. At the scale of the map this will resamble the border just fine. Not that
// the boder start at the Pakistan border and runs north east to end in the middle of the region at the
// location of a gletcher.
// More details see: https://app.asana.com/0/1168892012788854/1201906445884779/f
const points = [
    [32.7736633,74.4690583],[32.9342052,74.3048108],[33.0398336,74.3193945],[33.0910488,74.1624464],
    [33.1986199,73.9985537],[33.2638734,74.0011001],[33.3050917,74.1353624],[33.4066027,74.1805024],
    [33.4871471,74.1707799],[33.5714742,74.0950837],[33.5830458,74.0152208],[33.7319886,73.9617473],
    [33.8281919,74.0619811],[33.9006578,74.2768009],[34.0410016,74.1282572],[34.1011713,73.9194172],
    [34.3793074,73.7490616],[34.6805581,73.9797157],[34.779759,74.3069611],[34.6324122,75.0306625],
    [34.5316206,75.8050352],[34.681602,76.2697719],[34.8011091,76.488307],[34.7394972,76.6881757],
    [34.9417783,76.7553783],[34.9790724,76.8675074],[34.9293726,76.9929457],[35.0054433,77.0127793]
];

function KashmirBorder(props) {
    const [state] = useStateContext(['pan', 'zoom']);
    const resultSet = useModel(GeoModel, 
            (m) => ({
                status: m.status,
                transformation: m.getTransformationString(),
                scale: 1 / (m.getTransformation().objectScaleFact.x || 1)
            }), {});

    if (resultSet.status !== GeoModel.Status.SUCCESS) {
        return null;
    }

    const path = createPath([points.map((p) => ([p[1], p[0]]))], false);
    const panZoom = (state.pan) ? state.zoom : 1;
    const style = {
        ...props.style,
        strokeWidth: 2 * resultSet.scale / panZoom + 'px',
        strokeDasharray: .01 / panZoom
    }
    
    return <g transform={resultSet.transformation} id="kasmir-border">
        <path d={path} style={style}/>
    </g>;
}


KashmirBorder.defaultProps = {
    style: {
        stroke: '#cfcfcf',
        fill: 'none'
    }
};


export {KashmirBorder};
